import { useProjectStore } from 'store/useProjectStore'
import { IconSparkles } from '@tabler/icons-react'
import { PageHeader } from './PageHeader'
import { ModalV2 } from './Common/ModalV2'
import ProjectForm from './ProjectForm'

export const NewProjectModal = () => {
  const { showNewProjectModal, setShowNewProjectModal } = useProjectStore()

  const handleCreateProject = async () => {
    setShowNewProjectModal(false)
  }

  return (
    <ModalV2
      open={showNewProjectModal}
      onClose={() => setShowNewProjectModal(false)}
      includePadding={false}
      includeCloseButton={true}
    >
      <div className="mx-auto flex flex-col p-4">
        <PageHeader icon={IconSparkles} title={`Create a new project`} />
        <ProjectForm onSubmit={handleCreateProject} />
      </div>
    </ModalV2>
  )
}
